// extracted by mini-css-extract-plugin
export default {"label_spec":"AnnouncementFormModal_label_spec__RFuMW","formBody":"AnnouncementFormModal_formBody__exvny","loadingRow":"AnnouncementFormModal_loadingRow__l12L2"};